export const transformCaretKeysToDot = (obj) => {
  if (obj && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      const newKey = key.replace(/\^/g, '.');
      acc[newKey] = transformCaretKeysToDot(obj[key]);

      return acc;
    }, Array.isArray(obj) ? [] : {});
  }

  return obj;
};
